import { render, staticRenderFns } from "./NuevoInforme.vue?vue&type=template&id=acc0d7ce&scoped=true&"
import script from "./NuevoInforme.vue?vue&type=script&lang=js&"
export * from "./NuevoInforme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc0d7ce",
  null
  
)

export default component.exports